import * as $ from 'jquery';
import { Helper } from "./helper";

export class Login {
    static formSelector: string = 'form';
    static formValidator: JQueryValidation.Validator;

    static init(): void {
        Helper.setupCheckboxClickEvent();
        Helper.setupMustBeTrueValidation();

        // get validator object
        this.formValidator = $(this.formSelector).validate();

        // setup form field validation on focusout event
        Helper.setupValidationOnFocusOut(this.formValidator);
    }
}